import React from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import { useLandingContent, resolveImageUrl } from '../useLandingContent';

export default function Servizi() {
  const { content } = useLandingContent();
  const services = content.servizi || [];
  return (
    <section id="servizi" className="py-20 sm:py-28 bg-stone-50" data-testid="section-servizi">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <p className="text-[11px] font-black text-primary uppercase tracking-widest mb-3">— I Nostri Servizi</p>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-stone-900 mb-4">
            Tutto ciò che serve per la tua casa,<br />
            <span className="text-stone-500">un solo interlocutore.</span>
          </h2>
          <p className="text-lg text-stone-600">Cinque settori specialistici, una squadra interna di professionisti e oltre {new Date().getFullYear() - 2000} anni di mestiere alle spalle.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <article key={s.id || i} data-testid={`servizio-${s.id || i}`}
              className={`group relative overflow-hidden rounded-lg bg-white border border-stone-200 hover:border-primary transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''}`}>
              <div className={`relative overflow-hidden ${i === 0 ? 'h-72 lg:h-96' : 'h-56'}`}>
                <img src={resolveImageUrl(s.image)} alt={`${s.name} a Calcinato e Brescia`} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-950/20 to-transparent" />
                <span className="absolute top-4 left-4 px-2.5 py-1 bg-primary text-white text-[10px] font-black rounded uppercase tracking-widest">0{i + 1}</span>
              </div>
              <div className="p-6">
                <h3 className={`font-black text-stone-900 mb-2 ${i === 0 ? 'text-2xl' : 'text-xl'}`}>{s.name}</h3>
                <p className="text-sm text-stone-600 mb-4 leading-relaxed">{s.description}</p>
                <ul className="space-y-1.5 mb-5">
                  {(s.bullets || []).map((b, k) => (
                    <li key={k} className="flex items-start gap-2 text-sm text-stone-700">
                      <Check size={14} className="text-primary mt-0.5 flex-shrink-0" /> {b}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => document.getElementById('contatti')?.scrollIntoView({ behavior: 'smooth' })}
                  className="inline-flex items-center gap-1 text-sm font-black text-stone-900 group-hover:text-primary transition-colors">
                  Richiedi info <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
